import React from "react";
import { Wrench } from "lucide-react";

import type { CatalogService } from "types/service";

interface Props {
    serviceData?: CatalogService["data"];
    formatMessage: (key: string) => string;
    className?: string;
}

type BringFieldDef = {
    value: boolean | undefined;
    i18nYes: string;
    i18nNo: string;
};

type ResolvedBringField = BringFieldDef & { value: boolean };

const BRING_FIELDS = [
    {
        field: "bring_tools" as const,
        i18nYes: "our_services.label.bring_tools_yes",
        i18nNo: "our_services.label.bring_tools_no",
    },
    {
        field: "bring_products" as const,
        i18nYes: "our_services.label.bring_products_yes",
        i18nNo: "our_services.label.bring_products_no",
    },
];

export function hasProviderServiceBringNotes(serviceData?: CatalogService["data"]): boolean {
    if (!serviceData) {
        return false;
    }

    return BRING_FIELDS.some(({ field }) => serviceData[field] !== undefined);
}

export const ProviderServiceBringNotes: React.FC<Props> = ({
    serviceData,
    formatMessage,
    className = "mt-2 space-y-1.5 border-t border-border pt-2",
}) => {
    if (!serviceData) {
        return null;
    }

    const fields = BRING_FIELDS.map(({ field, ...rest }) => ({
        ...rest,
        value: serviceData[field],
    })).filter((f): f is ResolvedBringField => f.value !== undefined);

    if (fields.length === 0) {
        return null;
    }

    return (
        <div className={className}>
            {fields.map(({ value, i18nYes, i18nNo }) => (
                <div key={i18nYes} className="flex items-start gap-2">
                    <Wrench className="mt-0.5 h-3 w-3 shrink-0 text-muted-foreground" />
                    <p className="text-xs italic leading-snug text-muted-foreground">
                        {value ? formatMessage(i18nYes) : formatMessage(i18nNo)}
                    </p>
                </div>
            ))}
        </div>
    );
};
